import { createApi } from '@reduxjs/toolkit/query/react';
import { APP_PORTFOLIOS_API } from 'services/constants';
import { rawBaseQuery } from 'services/shared';
import { PortfolioResponse } from 'services/types';

export const portfoliosApi = createApi({
  reducerPath: APP_PORTFOLIOS_API,
  baseQuery: rawBaseQuery,
  endpoints: (builder) => ({
    getPortfoliosList: builder.query<PortfolioResponse[], string>({
      query: (context) => encodeURI(`/contexts/${context}/portfolios`),
    }),
  }),
});

export const { useGetPortfoliosListQuery, useLazyGetPortfoliosListQuery } =
  portfoliosApi;
